import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import useUserStore from 'components/storeUserData';

function Header({
  variant = 'default',
  className = '',
  isCollapsed,
  ...props
}) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const location = useLocation();

  const notifications = [
    { id: 1, title: 'New data available', message: 'Latest dataset has been processed', time: '5 min ago', read: false },
    { id: 2, title: 'System update', message: 'System will be updated tonight', time: '1 hour ago', read: false },
    { id: 3, title: 'Report generated', message: 'Your monthly report is ready to download', time: '2 hours ago', read: true },
  ];

  const navItems = [
    { name: 'Dashboard', path: '/dashboard-overview', icon: 'LayoutDashboard' },
    { name: 'Analytics Data', path: '/analytics', icon: 'ChartNoAxesCombined' },
    { name: 'Users', path: '/users', icon: 'Users' },
    { name: 'Inspiration', path: '/inspiration', icon: 'Image' },
    { name: 'Home Inspiration', path: '/home-inspiration', icon: 'Image' },
    { name: 'Blogs', path: '/blogs', icon: 'Rss' },
    { name: 'Logout', path: '/', icon: 'LogOut' }
    // { name: 'Form Editor', path: '/form-editor', icon: 'FileEdit' },
  ];

  const mobileNavItems = [

    {
      name: 'Dashboard',
      icon: 'LayoutDashboard',
      path: '/dashboard-overview',
    },
    {
      name: 'Analytics Data',
      path: '/analytics',
      icon: 'ChartNoAxesCombined'
    },
    {
      name: 'Inspiration',
      icon: 'Image',
      path: '/inspiration',
    },
    {
      name: 'Home Inspiration',
      icon: 'Image',
      path: '/home-inspiration',
    },
    {
      name: 'Blogs',
      icon: 'Rss',
      path: '/blogs',
    },
    {
      name: 'Generation Failed Errors',
      icon: 'Rss',
      path: '/generationFailedErrors',
    },
    {
      name: 'Third Party Api Errors',
      icon: 'Rss',
      path: '/third-party-api-errors',
    },
    {
      name: 'Email Marketing',
      icon: 'Rss',
      path: '/email-marketing',
    },


    {
      name: 'Users',
      icon: 'Users',
      path: '/users',
    },
    // {
    //   name: 'Form Editor',
    //   icon: 'FileEdit',
    //   path: '/form-editor',
    // },
    {
      name: 'Eterniai Academy Inquiry',
      icon: 'FileText',
      path: '/academy-inquiry',
    },
    {
      name: 'Academy Course Purchases',
      icon: 'ShoppingCart',
      path: '/academy-course-purchases',
    },
    // {
    //   name: 'Settings',
    //   icon: 'Settings',
    //   path: '/settings',
    // },
    {
      name: 'Logout',
      icon: 'LogOut',
      path: '/',
    }
  ];

  const isCompact = variant === 'compact';

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Searching for:', searchQuery);
    // Implement search functionality
  };

  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen);
    if (isSearchOpen) setIsSearchOpen(false);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
    if (isNotificationsOpen) setIsNotificationsOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header
      className={`
        bg-white border-b border-gray-200 
        ${isCompact ? 'py-2' : 'py-4'}
        ${className}
      `}
      {...props}
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between px-4">
          {/* Left: Logo */}
          <Link to="/dashboard-overview" className="flex lg:hidden items-center">
            <img src="/favicon.ico" alt="Favicon" width={32} height={32} />
            <span className="ml-2 text-xl font-bold text-gray-900">EternitAI</span>
          </Link>

          {/* Right: Mobile Menu Button (Hamburger) */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="inline-flex items-center p-2 text-gray-700 rounded-md hover:bg-gray-100 md:hidden"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          {/* Right: Desktop Navigation */}
          <nav className="hidden md:flex ml-8 gap-x-4">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`${item.name == 'Logout' && 'lg:hidden'} px-3 py-2 rounded-md text-sm font-medium flex items-center ${location.pathname === item.path
                  ? "text-primary-700 bg-primary-50"
                  : "text-gray-700 hover:text-primary-600 hover:bg-gray-50"
                  }`}
              >
                <Icon name={item.icon} size={16} className="mr-1.5" />
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white px-4 py-2">
            {mobileNavItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => {
                  if (item.name === "Logout") {
                    useUserStore.getState().clearUserData();
                  }
                  setIsMobileMenuOpen(false);
                }}
                className="block py-2 text-sm text-gray-700 hover:text-primary-600"
              >
                <Icon name={item.icon} size={16} className="mr-2 inline" />
                {item.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;